<template>
  <div class="user-index">
    <!--个人信息-->
    <div class="user-header">
      <div class="user-header-inner">
        <div class="user-info">
          <div class="user-info_1">请在分销设置-页面背景图设置-设置背景</div>
        </div>
        <div >
				<div class="agent">
					<div class="agent_1">
						<div class="agent_1_1">用户名：</div>
						<div class="agent_1_2">某某某</div>
					</div>
					<div class="agent_2">
						<div class="agent_2_1">推荐人：</div>
						<div class="agent_2_2">平台</div>
					</div>
				</div>

        <div style="border: 1px solid #f5f5f5;width: 90%;height: 1px;margin: auto;"></div>
				<div class="d-s-c p-30-0 mt20">
					<div class="flex-1 d-c-c d-c">
						<div class="red">
							<div class="f22">¥</div>
							<div class="f40">0</div>
						</div>
						<div class="f28">待结算</div>
					</div>

					<div class="flex-1 d-c-c d-c">
						<div class="red">
              <div class="f22">¥</div>
							<div class="f40">0</div>
						</div>
						<div class="f28">可提现</div>
					</div>

					<div class="flex-1 d-c-c d-c">
						<div class="red">
							<div class="f22">¥</div>
							<div class="f40">0</div>
						</div>
						<div class="f28">待提现</div>
					</div>
					<div class="flex-1 d-c-c d-c">
						<div class="red">
              <div class="f22">¥</div>
							<div class="f40">0</div>
						</div>
						<div class="f28">已提现金额</div>
					</div>
				</div>
				<div style="width: 90%;margin: auto;">
					<button type="primary" class="btn-red" >去提现</button>
				</div>
			</div>
      </div>


    </div>


    <div class="btn-edit-del">
          <div class="btn-del" @click.stop="$parent.$parent.onDeleleItem(index)">删除</div>
        </div>
  </div>
</template>

<script>
export default {
  components: {},

  data() {
    return {};
  },
  props: ["item", "index", "selectedIndex"],
  methods: {},
};
</script>

<style lang="scss" scoped>
@import '../../../../../components/page/static/iconfont2.css';

.f22{
  font-size: 11px;
  display: inline-block;
}
.f40{
  font-size: 20px;
  color: rgb(226,35,26);display: inline-block;
}
.btn-red{
  width: 100%;
  height: 40px;
  border-radius: 20px;
  text-align: center;
  line-height: 40px;
  background: rgb(226,35,26);font-size: 14px;
  border: none;
  color: #fff;
  box-shadow: 0 3px 12px rgba(226,35,26, .5);
  margin-bottom: 40px;

}
.user-info_1{
  width: 100%;
  height: 90px;
  text-align: center;
  line-height: 90px;
  background: #f79f42;font-weight: bold;color: #000;
}
.f28{
  font-size: 12px;
  color:#606060;
}
.agent{
  
  width:90%;
  height:50px;
  display: flex;
  line-height: 50px;
  margin: auto;
  .agent_1{
    flex: 1;
    
    .agent_1_1{
      color: #000;  
      
      z-index: 1000;
      font-size: 14px;
  
      display: inline-block;
    }
    .agent_1_2{
font-weight: bold;
font-size: 20px;
      color: #000;    display: inline-block;
    }
  }
  .agent_2{
    flex: 1;
    text-align: right;
    .agent_2_1{
      color: #cfcfcf;  z-index: 1000;
      font-size: 14px;   display: inline-block;
    }
    .agent_2_2{font-size: 14px;
      color: #000;     display: inline-block;
    }
  }
}



@import '../../../../../components/page/static/iconfont.css';
.group-hd .left .min-name {
    margin-right: 5px;
    font-size: 15px;
    line-height: 45px;
}
.user-header {
  position: relative;
  // background: #e2231a;
}
</style>



// WEBPACK FOOTER //
// src/views/page/tabbar/diy/model/AgentInfo.vue